import { PDxUserPermission } from "../PDxUserPermission.enum";

export class CurrentUser {
    constructor() {
        this.userPermissions = [];
    }

    userId: string;
    firstName: string;
    lastName: string;
    isPDxAdmin: boolean;
    initials: string;
    backgroundImage: string;
    userPermissions: PDxUserPermission[];
    isImpersonating: boolean;
}